export default {
    state: {
        visibility_modal_upload_file: false,
        type_modal_upload_file: null,
        doc_id_modal_upload_file: null
    },
    mutations: {
        SET_VISIBILITY_MODAL_UPLOAD_FILE(state, payload) {
            state.visibility_modal_upload_file = payload.show;
            state.type_modal_upload_file = payload.type;
            state.doc_id_modal_upload_file = payload.doc_id;
        }
    },
    actions: {
        setVisibilityModalUploadFile({commit}, payload) {
            commit('SET_VISIBILITY_MODAL_UPLOAD_FILE', payload)
        }
    },
    getters: {
        get_visibility_modal_upload_file: state => state.visibility_modal_upload_file,
        get_type_modal_upload_file: state => state.type_modal_upload_file,
        get_doc_id_modal_upload_file: state => state.doc_id_modal_upload_file
    }
}
